import React, { useState } from 'react';
import Layout from '../../components/Layout/Layout';
import Card from '../../components/Card/Card';
import CardOverlay from '../../components/CardOverlay/CardOverlay';
import styles from './CardOverlayPage.module.css';

const CardOverlayPage = () => {
  const [selectedCard, setSelectedCard] = useState(null);

  const handleCardSelect = (cardId) => {
    console.log('CardOverlayPage - Card selected:', cardId);
    setSelectedCard(cardId);
  };

  const handleCloseOverlay = () => {
    console.log('CardOverlayPage - Closing overlay');
    setSelectedCard(null);
  };

  return (
    <Layout width="1440px">
      <div className={styles.cardOverlayStack}>
        <Card
          cardId="ff271c2a-d2a7-426f-bbe1-599e98d870ba"
          size="Grande"
          initialOpen={true}
          disableHover={false}
          autoPlay={true}
          hoverPlay={true}
          controls={false}
          loop={true}
          rotation={0}
          onCardSelect={handleCardSelect}
        />
        
        {selectedCard && (
          <CardOverlay
            cardId={selectedCard}
            onClose={handleCloseOverlay}
          />
        )}
      </div>
    </Layout>
  );
};

export default CardOverlayPage;